import  firebase from 'firebase'
// import firestore from 'firebase/firestore'

// Your web app's Firebase configuration
 var firebaseConfig = {
  apiKey: "AIzaSyCzUG0QNAYadwi_rhg3IAfLmr_uc8_8New",
  authDomain: "landing-pages-573fb.firebaseapp.com",
  databaseURL: "https://landing-pages-573fb.firebaseio.com",
  projectId: "landing-pages-573fb",
  storageBucket: "landing-pages-573fb.appspot.com",
  messagingSenderId: "385793063542",
  appId: "1:385793063542:web:fbff315c63e3c9cd02bd57",
  measurementId: "G-3X6RZPL5F9"
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
firebase.analytics();

export default firebaseApp.firestore()